<header class="app-header" [class.hidden]="!isVisible">
  <div class="left">
    <a routerLink="/" class="icon-button" title="Home">
      <img [src]="logoSrc" alt="McDonald's logo" />
    </a>
  </div>

  <nav class="nav-links">
    <a routerLink="/">Home</a>

    @if (authService.isLoggedIn()) {
      <div class="dropdown">
        <a class="dropdown-trigger">Team Portal</a>

        <div class="dropdown-menu">
          @if (authService.canAccessCrewPortal()) {
            <a routerLink="/crew">Crew Portal</a>
          }

          @if (authService.canAccessManagerPortal()) {
            <a routerLink="/manager">Manager Portal</a>
          }

          @if (authService.canAccessAdminPortal()) {
            <a routerLink="/admin">Admin Portal</a>
          }
        </div>
      </div>
    }

    <div class="dropdown">
      <a class="dropdown-trigger">Meet The Team</a>
      <div class="dropdown-menu">
        <a routerLink="/aboutUs">About Us</a>
        <a routerLink="/team">Team Members</a>
        <a routerLink="/applications">Apply Now</a>
      </div>
    </div>

    <div class="dropdown">
      <a class="dropdown-trigger">Our Community</a>
      <div class="dropdown-menu">
        <a routerLink="/community">Community</a>
        <a routerLink="/donations">Donations</a>
        <a routerLink="/contact-us">Contact Us</a>
      </div>
    </div>

    <div class="dropdown">

      <a
        class="dropdown-trigger order-now-trigger"
        routerLink="/order"
      >
        Order Now
      </a>

      <div class="dropdown-menu order-dropdown">

        <div class="order-dropdown-inner">

          <a
            class="order-btn mcdonalds"
            [href]="getOrderLink('mcdonalds')"
            target="_blank"
            rel="noopener noreferrer"
          >

            <img
              [src]="branding.logoUrl()"
              alt=""
            />

            McDonald's App
          </a>


          <a
            class="order-btn doordash"
            [href]="getOrderLink('doordash')"
            target="_blank"
            rel="noopener noreferrer"
          >
            DoorDash
          </a>


          <a
            class="order-btn ubereats"
            [href]="getOrderLink('ubereats')"
            target="_blank"
            rel="noopener noreferrer"
          >
            Uber Eats
          </a>

        </div>

      </div>

    </div>

  </nav>

  <div class="right">
    @if (!showAdminButton) {
      <button
        (click)="onAdminClick()"
        class="admin-button"
        title="Login">
        <img src="assets/assets/account.svg" alt="Login" />
      </button>
    }

    @if (showAdminButton) {
      <button
        (click)="onAdminClick()"
        class="admin-button"
        title="Admin Dashboard">
        <img src="assets/assets/account.svg" alt="Admin Dashboard" />
      </button>
    }
    <button class="hamburger" (click)="toggleMobileMenu()" [class.open]="mobileMenuOpen">
      <div class="burger-icon">
        <div class="bun-top"></div>
        <div class="patty"></div>
        <div class="bun-bottom"></div>
      </div>
    </button>
  </div>
</header>

<div class="mobile-menu" [class.open]="mobileMenuOpen" (click)="closeMobileMenu()">
  <div class="mobile-menu-inner" (click)="$event.stopPropagation()">

    <a routerLink="/" (click)="closeMobileMenu()">Home</a>

        @if (authService.isLoggedIn()) {
    <div class="mobile-group">
      <span class="mobile-group-label">Team Portal</span>
              @if (authService.canAccessCrewPortal()) {
                <a routerLink="/crew">Crew Portal</a>
              }

              @if (authService.canAccessManagerPortal()) {
                <a routerLink="/manager">Manager Portal</a>
              }

              @if (authService.canAccessAdminPortal()) {
                <a routerLink="/admin">Admin Portal</a>
              }
    </div>
    }
    <div class="mobile-group">
      <span class="mobile-group-label">Meet The Team</span>
      <a routerLink="/aboutUs" (click)="closeMobileMenu()">About Us</a>
      <a routerLink="/team" (click)="closeMobileMenu()">Team Members</a>
      <a routerLink="/applications" (click)="closeMobileMenu()">Apply Now</a>
    </div>

    <div class="mobile-group">
      <span class="mobile-group-label">Our Community</span>
      <a routerLink="/community" (click)="closeMobileMenu()">Community</a>
      <a routerLink="/donations" (click)="closeMobileMenu()">Donations</a>
      <a routerLink="/contact-us" (click)="closeMobileMenu()">Contact Us</a>
    </div>

    <div class="mobile-group">

      <span class="mobile-group-label">
        Order Now
      </span>

      <a
        class="order-btn mcdonalds mobile-order"
        [href]="getOrderLink('mcdonalds')"
        target="_blank"
        rel="noopener noreferrer"
        (click)="closeMobileMenu()"
      >
        <img
          [src]="branding.logoUrl()"
          alt=""
        />

        McDonald's App
      </a>


      <a
        class="order-btn doordash mobile-order"
        [href]="getOrderLink('doordash')"
        target="_blank"
        rel="noopener noreferrer"
        (click)="closeMobileMenu()"
      >
        DoorDash
      </a>


      <a
        class="order-btn ubereats mobile-order"
        [href]="getOrderLink('ubereats')"
        target="_blank"
        rel="noopener noreferrer"
        (click)="closeMobileMenu()"
      >
        Uber Eats
      </a>

    </div>

  </div>
</div>
